import React from "react";
import { Container } from "react-bootstrap";

export default function Privacy() {
  return (
    <Container style={{ paddingTop: "40px", paddingBottom: "40px" }}>
      <h1>Privacy Policy</h1>
      <p>
        JSONHelper processes JSON in your browser. We do not store the JSON you paste
        into the tool on our servers.
      </p>
      <p>
        We may use cookies for analytics and advertising (such as Google AdSense) where applicable.
        You can control cookies through your browser settings.
      </p>
      <p>
        Contact: <a href="mailto:info@uvgrade.com">info@uvgrade.com</a>
      </p>
    </Container>
  );
}